import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["checkbox", "field"];
  static values = {
    checkboxGroup: String,
    selectField: String,
    radioGroup: String
  }

  connect() {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.addEventListener("change", this.toggleClass.bind(this));
    });

    // Add listeners for other field types if they exist
    this.fieldTargets.forEach((field) => {
      field.addEventListener("change", this.toggleClass.bind(this));
    });

    // Run validation on load
    this.toggleClass();
  }

  toggleClass(event) {
    setTimeout(() => {
      const disabledButton = document.getElementById("btnContinueDisabled")
      const submitButton = document.getElementById("btnContinue")

      let isValid = true;

      // If checkbox group is specified, validate it
      if (this.hasCheckboxGroupValue && this.checkboxGroupValue) {
        const checkedCheckboxes = document.querySelectorAll(`input[name="${this.checkboxGroupValue}"]:checked`);
        isValid = isValid && checkedCheckboxes.length > 0;
      } else if (this.checkboxTargets.length > 0) {
        // Fallback to old behavior if no group specified
        const checkedCheckboxes = document.querySelectorAll(".form-check-input:checked");
        isValid = isValid && checkedCheckboxes.length > 0;
      }

      // If select field is specified, validate it
      if (this.hasSelectFieldValue && this.selectFieldValue) {
        const selectField = document.querySelector(this.selectFieldValue);
        if (selectField) {
          isValid = isValid && selectField.value && selectField.value.length > 0;
        }
      }

      // If radio group is specified, validate it
      if (this.hasRadioGroupValue && this.radioGroupValue) {
        const checkedRadio = document.querySelector(`input[name="${this.radioGroupValue}"]:checked`);
        isValid = isValid && checkedRadio !== null;
      }

      if (isValid) {
          submitButton.classList.remove("d-none");
          submitButton.classList.add("d-block");
          disabledButton.classList.add("d-none");
          disabledButton.classList.remove("d-block");
      } else {
          disabledButton.classList.remove("d-none");
          disabledButton.classList.add("d-block");
          submitButton.classList.add("d-none");
          submitButton.classList.remove("d-block");
      }
    }, 0);
  }
}

